import { useMarkdownContent } from "../hooks/useMarkdownContent"

interface MarkdownProps {
  path: string
}

export function Markdown({ path }: MarkdownProps) {
  const { content, loading, error } = useMarkdownContent(path)

  if (loading) {
    return (
      <div className="loading">
        <p>Loading...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="error">
        <h1>Error Loading Content</h1>
        <p>{error.message}</p>
      </div>
    )
  }

  if (!content) {
    return null
  }

  return <div dangerouslySetInnerHTML={{ __html: content.html }} />
}
